import { Component, OnInit, Injector, ViewChild } from '@angular/core';

import { ContactService } from '../../services/contact.service';
import { emailSubscribe } from '../../models/subsribe.model';
import { NotificationService } from '../../services/notification.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-newslettersubscribe',
  templateUrl: './newslettersubscribe.component.html',
  styleUrls: ['./newslettersubscribe.component.css']
})
export class NewslettersubscribeComponent implements OnInit {

  _email = new emailSubscribe;
  notifier = this.injector.get(NotificationService);
  //frm: NgForm;
  @ViewChild('f', {static:true}) frm;

  constructor(private _contactservice: ContactService,private injector: Injector) { }

  ngOnInit() {
  }

  onSubmit() {
    
    this._contactservice.emaiSubscribe(this._email).subscribe(data => this._email = data,error => this.notifier.showError(error.message),() => {this.notifier.showSuccess(this._email.emailid + " Subscribed!"); this.frm.resetForm();});

    //this.notifier.showSuccess('SUCCESS!! :-)\n\n' + this._email.emailid);
    //if(!this._errmsg)
    //  alert('SUCCESS!! :-)\n\n' + this._email.emailid)
  }
}
